/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Following_Level_AllInputs */

const en_following_level_all = /** @type {(inputs: Following_Level_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All changes`)
};

/**
* | output |
* | --- |
* | "All changes" |
*
* @param {Following_Level_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const following_level_all = /** @type {((inputs?: Following_Level_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Following_Level_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_following_level_all(inputs)
});